import React, { useEffect } from 'react';

const Mission = () => {
  useEffect(() => { document.title = 'Mission | Afterimage Labs'; }, []);

  return (
    <main>
      <section className="ai-pagehead">
        <div className="ai-wrap">
          <h1>Make a missed diagnosis expensive to ignore.</h1>
          <p>
            Right now, when a diagnosis gets missed, the family carries the cost and
            the hospital rarely hears about it. Hospitals should answer to the
            patients who pay for their care.
          </p>
        </div>
      </section>

      <section className="ai-section">
        <div className="ai-wrap">
          <h2>For patients</h2>
          <div className="ai-body">
            <p>
              Your medical records belong to you. Even so, most people never learn
              whether their diagnosis was late. Checking means
              requesting records, reading hundreds of pages of clinical shorthand, and
              finding a lawyer willing to take the case. Almost nobody gets through all
              three.
            </p>
            <p>
              We do that work for them. A patient who suspects something went wrong can
              get a real answer from their own records, and if they were harmed, a way
              to be compensated for it.
            </p>
          </div>
        </div>
      </section>

      <section className="ai-section">
        <div className="ai-wrap">
          <h2>For hospitals and clinics</h2>
          <div className="ai-body">
            <p>
              The same review that helps one patient also shows where a system keeps
              failing: the imaging result that doesn't reach the ordering doctor, the
              referral that quietly expires. Providers rarely see these patterns
              because nobody puts the cases side by side.
            </p>
            <p>
              We do, and we'd rather hand that to a hospital early than read about it
              in a deposition later.
            </p>
          </div>
        </div>
      </section>

      <section className="ai-section">
        <div className="ai-wrap">
          <h2>Why accountability works</h2>
          <div className="ai-body">
            <p>
              Hospitals already know diagnostic errors are common. What's missing is a
              reason to spend money catching them before they happen. When more missed
              diagnoses get found and paid for, catching them early becomes the cheaper
              option. That doesn't take a new government program. It takes someone
              reading the records and a real consequence when the answer is bad.
            </p>
          </div>
        </div>
      </section>

      <section className="ai-section">
        <div className="ai-wrap">
          <h2>How we work</h2>
          <div className="ai-pairs">
            <div>
              <h3>Patient first</h3>
              <p>When the patient's interest and ours disagree, the patient wins.</p>
            </div>
            <div>
              <h3>The record decides</h3>
              <p>We say what the chart shows and nothing more. A weak case gets an honest no.</p>
            </div>
            <div>
              <h3>Not anti-doctor</h3>
              <p>Most errors come from broken systems, not bad people. We'd rather fix the system.</p>
            </div>
            <div>
              <h3>Software where it helps</h3>
              <p>Machines read fast. People make the judgment calls. We use both for what they're good at.</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Mission;
